function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M120 68l27.46 26.43A5 5 0 00156 90.9V21.09a5 5 0 00-8.54-3.54L120 44V16a12 12 0 00-12-12H16A12 12 0 004 16v80a12 12 0 0012 12h92a12 12 0 0012-12z",
  "data-name": "Video_ic"
});

var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 112",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgVideo;